/**
 * A persistent scrollbar, because overlay scrollbars (macOS default) stay
 * hidden until the user scrolls, leaving no hint that content has been
 * pushed off-screen. Styling the WebKit scrollbar opts the element out of
 * overlay mode, so a bar is drawn whenever there is overflow; Firefox can't
 * be opted out, so it gets a matching thin themed bar.
 */
export const PERSISTENT_SCROLLBAR = [
  '[scrollbar-width:thin] [scrollbar-color:var(--border)_transparent]',
  '[&::-webkit-scrollbar]:h-2.5 [&::-webkit-scrollbar]:w-2.5',
  '[&::-webkit-scrollbar-track]:bg-transparent',
  '[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border',
  '[&::-webkit-scrollbar-thumb:hover]:bg-muted-foreground',
].join(' ');
